export default __webpack_public_path__ + "static/media/ReuseDirBannerAdMOATX2026.782114a4.png";